import { render, staticRenderFns } from "./MergeJournalKasbonCombination.vue?vue&type=template&id=18190b24"
import script from "./MergeJournalKasbonCombination.vue?vue&type=script&lang=js"
export * from "./MergeJournalKasbonCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports